import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import validator from "validator";
import { jwtDecode } from "jwt-decode";
import posthog from 'posthog-js';

const SigninWithGoogle = ({page,user,setErrormsg, setStep, step, loader, setLoader, navigate, setUser}) => {
  
      
  const handleLoginSuccess = async(response) => {
    setErrormsg(null)
   
    // Handle successful login here
    console.log('Google Login Success:', response);
    var user_object = jwtDecode(response.credential);
        
    console.log(user_object);
    if(page === 'register'){
        //google
          
           
        
              try {
                console.log('hello')
                await axios
                  .post(process.env.REACT_APP_BACKEND_URL + "user/create-just-user", {
                    company_name: user.company_name,
                    email: user_object.email,
                    password: user_object.email,
                    first_name: user_object.given_name,
                    last_name: user_object.family_name,
                    registered_from_google: true,
                  })
                  .then((res) => {
                    if (res.data.status === "success") {
                      localStorage.setItem("user", JSON.stringify(res.data.user)); //store user data in local storage
                      // localStorage.setItem(
                      //   "organization",
                      //   JSON.stringify(res.data.organization)
                      // ); 
                      // setStep(step + 1);
                      setLoader(false);
                      setUser({...user,registeredFromGoogle: true,
                        email: user_object.email,
                    password: user_object.email,
                    first_name: user_object.given_name,
                    last_name: user_object.family_name,
                    userId: res.data.user.userId.S,
                   //  agreed: false
                      })
                      console.log(res.data.user)
                      document.getElementById("123").focus();
                    } else {
                      setErrormsg(res.data.msg);
                      setLoader(false);
                    }
                  })
                  .catch((err) => {
                    setLoader(false);
                  });
              } catch (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  console.error("Response data:", error.response.data);
                  setErrormsg(error.response.data.message);
                }
                setLoader(false);
              }
        
    }else{
            setErrormsg(null);
            setLoader(true);
            try {
                let user_data = await axios.post(
                  process.env.REACT_APP_BACKEND_URL + "get-user",
                  {
                    email: user_object.email,
                    password: user_object.email,
                    login_from_google: true
                  }
                )
                localStorage.setItem('user', JSON.stringify(user_data.data.user) )
        
              let org_id = user_data.data.user.relatedOrgs?.L[0]?.M?.org_id?.S || null;
        
             if(org_id){
              let org = await axios.post(
                process.env.REACT_APP_BACKEND_URL + "get-organization",
                { orgId: org_id }
              );
        
              localStorage.setItem('organization', JSON.stringify(org.data.organization) )
        
              navigate("/dashboard/");

              
             }else{
              navigate('/create-organization')
             }
        
              setLoader(false);
            } catch (error) {
              console.log(error)
              if (error.response && error.response.data) {
                console.error("Response data:", error.response.data);
                setErrormsg(error.response.data.message)
              }
              setLoader(false)
            }
    }
    // You can send the response.credential to your backend for further processing
  };

  const handleLoginFailure = (error) => {
    // Handle login failure here
    console.error('Google Login Failure:', error);
    console.log('r')
    setErrormsg('Google Login Failure:'+error)
  };

  return (
    <GoogleOAuthProvider  clientId="910554755020-8dlg999mposgad3p96e1ktpufbu3ia7n.apps.googleusercontent.com">
      <div className="App">
        {/* sign in with google */}
        <GoogleLogin
          onSuccess={handleLoginSuccess}
        onError={handleLoginFailure}
        /> 
      </div>
    </GoogleOAuthProvider>
  );
};

export default SigninWithGoogle;
